import React from 'react';
import * as _ from 'lodash';

import * as Styled from './MascotBanner.style';
import { Headline } from '@lce/slice-ui';

type TSizes = 'xl' | 'lg' | 'md' | 'sm';

export interface IMascotBannerProps {
  mascot: React.ReactNode;
  message: React.ReactNode | string;
  size?: TSizes;
}

const MascotBanner: React.FunctionComponent<IMascotBannerProps> = ({ mascot: Mascot, message, size }) => {
  return (
    <Styled.Banner>
      <Styled.BannerBox
        direction="column"
        reverse={ true }
        responsive={ true }
        align="center"
        justify="evenly"
        size={ size }
      >
        <Styled.Mascot>
          <Mascot />
        </Styled.Mascot>
        <Styled.Content>
          { _.isString(message) ?
            (
              <Headline tag="h2" >
                { message }
              </Headline>
            ) :
            message
          }
        </Styled.Content>
      </Styled.BannerBox>
    </Styled.Banner>
  );
};

MascotBanner.defaultProps = {
  size: 'xl',
};

export default MascotBanner;
